'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.iter = iter;
exports.disjunct = disjunct;
exports.conjunct = conjunct;

var _index = require('../index');

var _isAvailabilityObject = require('./isAvailabilityObject');

var _isAvailabilityObject2 = _interopRequireDefault(_isAvailabilityObject);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function iter(availability) {
    if (!(0, _isAvailabilityObject2.default)(availability)) return availability;

    return function (cal) {
        return new _index.AvailabilityIterator({
            availability: availability,
            cal: cal
        });
    };
}

function disjunct() {
    var objects = normalizeArgs(arguments);

    return function (cal) {
        var iterators = toIterators(objects, cal);

        return new _index.DisjunctiveTimeWindowsIterator({
            iterators: iterators,
            cal: cal
        });
    };
}

function conjunct() {
    var objects = normalizeArgs(arguments);

    return function (cal) {
        var iterators = toIterators(objects, cal);

        return new _index.ConjunctiveTimeWindowsIterator({
            iterators: iterators,
            cal: cal
        });
    };
}

function toIterators(objects, cal) {

    var objectsByType = _lodash2.default.groupBy(objects, function (obj) {
        if (typeof obj === 'function') return 'function';
        if ((0, _isAvailabilityObject2.default)(obj)) return 'availability';
        throw new Error('cannot compose unknown object');
    });

    return _lodash2.default.union((0, _lodash2.default)(objectsByType['function']).map(function (f) {
        return f(cal);
    }).value(), (0, _lodash2.default)(objectsByType['availability']).uniqWith(_lodash2.default.isEqual).map(function (a) {
        return iter(a)(cal);
    }).value());
}

function normalizeArgs(a) {
    var objects = Array.prototype.slice.call(a);

    if (objects.length === 1 && objects[0] instanceof Array) objects = objects[0];

    return objects;
}


//////////////////
// WEBPACK FOOTER
// ../node_modules/availability/dist/utils/iteratorFactory.js
// module id = 253
// module chunks = 0